<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="Search">
        <div class="searchTxt">设备编号</div>
        <el-input
          placeholder="请输入设备编号"
          size="medium"
          v-model="queryAlarms.orginId"
          @change="getAlarms()"
          clearable
        >
        </el-input>
      </div>
      <div class="Search">
        <div class="searchTxt">报警类型</div>
        <el-select
          v-model="queryAlarms.alarmType"
          @change="getAlarms()"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in alarmTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="Search">
        <div class="searchTxt">报警来源</div>
        <el-select
          v-model="queryAlarms.orginType"
          @change="getAlarms()"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in orginTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="Search1">
        <div class="searchTxt">报警时间</div>
        <el-date-picker
          @input="getAlarms()"
          v-model="Time"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          align="left"   
        >
          <!-- value-format="yyyy-MM-dd HH:mm:ss" -->
        </el-date-picker>
      </div>
    </div>

    <!-- 卡片区域 -->
    <el-card class="right-card">
      <!-- 角色信息表格区域 -->
      <el-table
        :data="roleList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
      >
        <!-- <el-table-column prop="alarmId" label="报警ID" width="100">
        </el-table-column> -->
        <el-table-column prop="alarmOriginName" label="使用人员">
        </el-table-column>
        <el-table-column prop="alarmOriginId" label="设备编号">
        </el-table-column>
        <el-table-column prop="alarmType" label="报警类型">
          <template v-slot="alarmTypeSlot">
            <span>{{
              alarmTypeSlot.row.alarmType == 1
                ? "发现目标车牌"
                : alarmTypeSlot.row.alarmType == 2
                ? "发现目标人员"
                : alarmTypeSlot.row.alarmType == 3
                ? "超出电子围栏"
                : alarmTypeSlot.row.alarmType == 4
                ? "sos求救"
                : alarmTypeSlot.row.alarmType == 5
                ? "位置监听异常"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="alarmOriginType" label="报警来源">
          <template v-slot="alarmOriginTypeSlot">
            <span>{{
              alarmOriginTypeSlot.row.alarmOriginType == 1
                ? "设备报警"
                : "中心服务器报警"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="alarmContent" label="报警内容">
          <template v-slot="alarmContentSlot">
            <span v-if="alarmContentSlot.row.alarmType == 1"
              >发现目标车牌:{{
                alarmContentSlot.row.alarmContent.match(
                  /"numberplateTxt":"([^"]+)"/
                )[1]
              }}</span
            >
            <span v-if="alarmContentSlot.row.alarmType == 2">
              发现目标人员:{{
                alarmContentSlot.row.alarmContent.match(
                  /"faceName":"([^"]+)"/
                )[1]
              }}</span
            >
            <span v-if="alarmContentSlot.row.alarmType == 3">
              超出电子围栏</span
            >
            <span v-if="alarmContentSlot.row.alarmType == 4"> sos求救</span>
            <span v-if="alarmContentSlot.row.alarmType == 5"> 位置监听异常</span>
          </template>
        </el-table-column>
        <el-table-column prop="alarmImg" label="报警图片">
          <template v-slot="alarmContentSlot">
            <el-image
              v-if="alarmContentSlot.row.alarmImg"
              style="width: 100px; height: 100px"
              :src="'data:image/png;base64,' + alarmContentSlot.row.alarmImg"
              :preview-src-list="[
                'data:image/png;base64,' + alarmContentSlot.row.alarmImg,
              ]"
            >
            </el-image>
            <span v-else>无</span>
          </template>
        </el-table-column>

        <el-table-column prop="alarmCreateTime" label="报警时间">
        </el-table-column>
        <el-table-column prop="wz" label="报警位置">
          <template v-slot="alarmContentSlot">
            <img
              v-if="
                alarmContentSlot.row.alarmLng !== 0 &&
                alarmContentSlot.row.alarmLat !== 0 &&
                alarmContentSlot.row.alarmLng !== null &&
                alarmContentSlot.row.alarmLat !== null
              "
              style="cursor: pointer"
              src="../../../assets/img/wargingRecord/map.png"
              @click="
                openMap(
                  alarmContentSlot.row.alarmLng,
                  alarmContentSlot.row.alarmLat,
                  
                )
              "
              alt=""
            />
            <span v-else
              >{{ alarmContentSlot.row.alarmLng }},{{
                alarmContentSlot.row.alarmLat
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryAlarms.pageNumber"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="queryAlarms.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
    <!-- 报警定位对话框 -->
    <el-dialog
      title="报警定位"
      :visible.sync="mapShowDialog"
      width="50%"
      :close-on-click-modal="false"
    >
      <!-- @close="clearMapDialogVisible()" -->
      <div style="height: 500px" id="container"></div>
    </el-dialog>
  </div>
</template>

<script>
// 引入百度地图样式
import custom_map_config from "../../../assets/css/custom_map_config4.json";
export default {
  data() {
    return {
      // 权限信息
      roleList: [],
      // 总数量
      total: 0,
      // 查询历史报警信息

      queryAlarms: {
        // 报警类型
        alarmType: "",
        // 开始时间
        beginTime: "",
        //结束时间
        endTime: "",
        // 设备号
        orginId: "",
        // 报警来源、
        orginType: "",
        //  当前页
        pageNumber: 1,
        //  每页显示多少条
        pageSize: 10,
      },

      //报警类型
      alarmTypeOptions: [
        {
          value: 1,
          label: "发现目标车牌",
        },
        {
          value: 2,
          label: "发现目标人员",
        },
        {
          value: 3,
          label: "超出电子围栏",
        },
        {
          value: 4,
          label: "SOS求救",
        },
        {
          value: 5,
          label: "位置监听异常",
        },
      ],
      //报警来源
      orginTypeOptions: [
        {
          value: 1,
          label: "设备报警",
        },
        {
          value: 2,
          label: "中心服务报警",
        },
      ],
      // 时间选择器选择的开始和结束时间
      Time: "",
      // 时间选择器
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 控制报警地图定位对话框显示与隐藏
      mapShowDialog: false,
    };
  },
  mounted() {
    this.getAlarms();
  },
  methods: {
    // 获取报警信息
    async getAlarms() {
      this.queryAlarms.beginTime = "";
      this.queryAlarms.endTime = "";
      if (this.Time) {
        // 开始时间
        this.queryAlarms.beginTime = this.Time[0];
        // 结束时间
        this.queryAlarms.endTime = this.Time[1];
      }

      const { data: res } = await this.$axios.get(
        `${this.$api}/alarm/history`,
        { params: this.queryAlarms }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data.rows) {
        this.roleList = res.data.rows;
        this.total = res.data.total;
      }
    },

    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryAlarms.pageSize = size;
      this.getAlarms();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryAlarms.pageNumber = current;
      this.getAlarms();
    },

    // 查看报警位置
    openMap(wgs8Lng, wgs8Lat) {
      // 显示对话框
      this.mapShowDialog = true;
      this.initMap(wgs8Lng, wgs8Lat);
    },
    // 调用百度地图
    initMap(wgs8Lng, wgs8Lat) {
      setTimeout(() => {
        // 创建地图实例
        this.BMapGL = BMapGL; //把百度地图库引入到this
        this.map = new BMapGL.Map("container"); //container为dom元素id，创建Map实例
        // 清除标记物
        this.map.clearOverlays();

        // 创建执法仪图标
        var mapIcon = new BMapGL.Icon(
          "../static/images/map/dw.png",
          new BMapGL.Size(50, 50)
        );

        // 创建Marker标注
        if (wgs8Lng && wgs8Lat) {
          if (wgs8Lng !== "0.0" && wgs8Lat !== "0.0") {
            // 转换后的才行设备经纬度
            var point = this.wgs84ToBd09(wgs8Lng, wgs8Lat);
            // console.log("point", point);
            var lng = point[0];
            var lat = point[1];
            let marker1 = new BMapGL.Marker(new BMapGL.Point(lng, lat), {
              icon: mapIcon,
              offset: new BMapGL.Size(0, -15),
            });
            this.map.addOverlay(marker1); //添加坐标
          }
        }

        setTimeout(() => {
          //  解决： Bug 百度地图centerAndZoom设置中心点后，中心点偏移
          //  原因：因为容器在隐藏和显示之间切换时，容器还没创建好，宽高为0，这时设置中心点就会是在左上角
          //  方法： 定时器setTimeout，延时设置中心点
          // 初始化地图,设置中心点坐标和地图级
          this.map.centerAndZoom(new BMapGL.Point(lng, lat), 18);
          // 创建城市选择控件
          var cityControl = new BMapGL.CityListControl({
            // 控件的停靠位置（可选，默认左上角）
            anchor: BMAP_ANCHOR_TOP_RIGHT,
            // 控件基于停靠位置的偏移量（可选）
            offset: new BMapGL.Size(50, 5),
          });
          // 将控件添加到地图上
          this.map.addControl(cityControl);
        }, 1000);

        // 初始化地图，设置中心点坐标和地图级别
        // this.map.centerAndZoom(new BMapGL.Point(this.lng, this.lat), 5);

        //开启鼠标滚轮缩放
        this.map.enableScrollWheelZoom(true);

        //地图旋转角度
        // this.map.setHeading(10);

        //地图倾斜角度
        // this.map.setTilt(19);

        //修改地图中心点
        // this.map.setCenter(this.lng, this.lat);

        //设置map显示类型
        //BMAP_SATELLITE_MAP 地图卫星模式
        //BMAP_NORMAL_MAP 普通模式
        this.map.setMapType(BMAP_NORMAL_MAP);

        var zoomCtrl = new BMapGL.ZoomControl({
          // 控件的停靠位置
          anchor: BMAP_ANCHOR_TOP_RIGHT,
          // 控件基于停靠位置的偏移量（可选）
          offset: new BMapGL.Size(10, 5),
        }); // 添加缩放控件
        this.map.addControl(zoomCtrl);

        var navi3DCtrl = new BMapGL.NavigationControl3D({
          anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        }); // 添加3D控件
        this.map.addControl(navi3DCtrl);

        //地图个性化样式
        this.map.setMapStyleV2({
          // styleId: "a0c43e8c7279db0a4a032712d0e4c32c", //官网地图api个性化获取
          // styleJson:[{}] //也可以json方式个性化
          styleJson: custom_map_config,
        });
      }, 300);
    },
    // 将wgs84转换成Bd09坐标系
    wgs84ToBd09(lng, lat) {
      var PI = (3.14159265358979324 * 3000.0) / 180.0;
      var x = parseFloat(lng),
        y = parseFloat(lat);
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * PI);
      // var bdLng = z * Math.cos(theta) + 0.0065;
      // var bdLat = z * Math.sin(theta) + 0.006;
      var bdLng = z * Math.cos(theta) + 0.0116;
      var bdLat = z * Math.sin(theta) + 0.0032;
      return [bdLng, bdLat];
    },
  },
};
</script>


<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.box-card {
  height: 400px !important;
  overflow: auto;
  margin: 0;
}

// el-dialog高度自适应，内容超出时中间出现滚动条
.common-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    position: relative;
    .el-dialog__header {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      width: 100%;
      height: 60px;
      z-index: 1;
    }
    .el-dialog__body {
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      max-height: 90vh; //最大高度为视口高度的90%
      padding-top: 80px;
      padding-bottom: 100px;
      z-index: 1;
    }
    .el-dialog__footer {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 80px;
      z-index: 1;
    }
  }
}

.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;

  // 用户名搜索区域
  .Search {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 20px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 100px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
  .Search1 {
    width: 450px;
    display: flex;
    align-items: center;
    margin-left: 30px;
    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 80px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Main/EvidenceCenter/warningRecord.vue